<div class="modal--wrap panel-show"
     ngxModalDraggable
     [expand]="false"
>
  <app-modal-header
    icon="user-plus"
    title="Пригласить собеседника"
    [modalDirective]="modalDirective"
    [bsModalRef]="bsModalRef"
    [expand]="false"
  ></app-modal-header>

  <div class="modal-body p-0">
    <div #scroll class="scroll-sidebar">
      <div class="container-fluid pt-5">
        <app-contacts-list
          [scroll]="scroll"
          [source]="'contacts'"
          [isCheckbox]="false"
          [search]="'local'"
          (onToggleUser)="toggleUser($event)"
          [Service]="Service"
        ></app-contacts-list>
      </div>
    </div>
  </div>
</div>
